import { get, writable } from 'svelte/store';
import { QualityDocumentService } from '../../services/quality-document.service';
import { ClassificationService } from '../../services/classification.service';
import { formatDateOnlyISO } from '../../utils/date-utils';
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export const clfDocumentTypeId = writable(0);
export const uploading = writable(false);
export const comparing = writable(false);
export async function initList(documentTypeCode) {
    let clfDocTypeId = await getDocumentTypeId(documentTypeCode);
    clfDocumentTypeId.set(clfDocTypeId);
    filter.set({ criteria: { clfDocumentTypeCode: documentTypeCode }, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    uploading.set(false);
    comparing.set(false);
    await load();
}
export async function initDetail(oid) {
    record.set(null);
    uploading.set(false);
    comparing.set(false);
    if (oid == 0) {
        record.set({
            oid: 0,
            name: '',
            version: '',
            documentDate: formatDateOnlyISO(new Date()),
            notes: '',
            clfDocumentTypeId: get(clfDocumentTypeId),
            storedFileId: -1
        });
    }
    else {
        let _resp = await QualityDocumentService.fetchQualityDocument(oid);
        record.set(_resp.payload);
    }
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await QualityDocumentService.getQualityDocuments(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export async function save() {
    let _record = get(record);
    return await QualityDocumentService.saveQualityDocument(_record);
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await QualityDocumentService.deleteQualityDocument(item.oid);
    await load();
}
export function onPageChange(pageNumber) {
    // console.log("onPageChange: " + pageNumber);
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
async function getDocumentTypeId(documentTypeCode) {
    var _a;
    let _resp = await ClassificationService.fetchValueByCode("QUALDOCTYP", documentTypeCode);
    let clf = _resp.payload;
    return (_a = clf === null || clf === void 0 ? void 0 : clf.oid) !== null && _a !== void 0 ? _a : 0;
}
export function openComparison() {
    comparing.set(true);
}
export function closeComparison() {
    comparing.set(false);
}
